import React from 'react';
import PropTypes from 'prop-types';

import AutoComplete from '../MultiAutoComplete';
import { name } from '../../../utils/helper';

const buildOption = (customer) => ({ label: name(customer), value: customer });

// const fetchSuggestions = (customers) => {
//   return (query) => {
//     const lcQuery = (query || '').toLowerCase();
//     return Promise.resolve(customers.filter((customer) => name(customer).toLowerCase().indexOf(lcQuery) >= 0).slice(0, 10))
//       .then((customers) => customers.map(buildOption));
//   };
// };

const loadOptions = (fetchCustomers) => (query) => {
  return fetchCustomers({ q: query }).then(customers => {
    console.log('customers', customers); // TODO q should be name
    return customers.response.data.map(buildOption);
  });
};

class CustomerAutoComplete extends React.Component {
  handleKeyPress = (evt) => {
    console.log('handleKeyPress', this.state);
    if (evt.key === 'Enter') {
      this.addCustomer();
    }

    evt.stopPropagation();
  };

  addCustomer = () => {
    //   const { tag } = this.state;
    //   if (tag && tag.trim()) {
    //     this.props.onChange(_.concat(this.props.tags, [tag]));
    //     this.setState({
    //       tag: '',
    //     });
    //   }
  };

  // handleTagChange = (tag, valid) => {
  //   console.log('handleTagChange', tag, valid);
  //   this.setState({
  //     tag,
  //   });
  // };

  render() {
    const { fetchCustomers, value, onAdd, onChange, label, helperText, allowCreate, ...other } = this.props;
    console.log('allowCreate', allowCreate);
    return (
      <AutoComplete
        label={label}
        helperText={helperText}
        loadOptions={loadOptions(fetchCustomers)}
        value={value ? buildOption(value) : null}
        onChange={(value) => {
          console.log('onChange', value);
          if (value.__isNew__) {
            onAdd && onAdd(value.value);
          } else {
            onChange(value.value);
          }
        }}
        {...other}
        id="customer"
        placeholder="Select Customer..."
        allowCreate={allowCreate}
      />);
  }
};

CustomerAutoComplete.propTypes = {
  fetchCustomers: PropTypes.func.isRequired,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

export default CustomerAutoComplete;

// const mapStateToProps = (state) => {
//   return {
//     availableTags: [], //state.getIn(['accounts', 'account', 'tags']).toJS(),
//   };
// };
//
// const mapDispatchToProps = (dispatch) => {
//   return bindActionCreators({
//     showDialog,
//   }, dispatch);
// };
//
// export default connect(mapStateToProps, mapDispatchToProps)(CustomerAutoComplete);



// WEBPACK FOOTER //
// ./src/components/Common/CustomerAutoComplete/index.js